import { StringUtils } from '@blumtechgroup/blum-ui-utils';

export interface OrganisationUser {
  first_name: string;
  last_name: string;
  email: string;
  active: boolean;
}

export interface ValidationErrors {
  first_name: string | boolean;
  last_name: string | boolean;
  email: string | boolean;
}

export const validationErrors: ValidationErrors = {
  first_name: 'Please provide a first name',
  last_name: 'Please provide a last name',
  email: 'Please provide a valid email address',
};

export enum OrganisationUserReducerAction {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ACTIVE,
  INIT,
}

export const organisationUserReducer = (state: OrganisationUser, action: { type: OrganisationUserReducerAction; value: any }): OrganisationUser => {
  switch (action.type) {
    case OrganisationUserReducerAction.FIRST_NAME:
      return { ...state, first_name: StringUtils.capitaliseFirst(action.value) };
    case OrganisationUserReducerAction.LAST_NAME:
      return { ...state, last_name: StringUtils.capitaliseFirst(action.value) };
    case OrganisationUserReducerAction.EMAIL:
      return { ...state, email: action.value?.toLowerCase() };
    case OrganisationUserReducerAction.ACTIVE:
      return { ...state, active: action.value };
    case OrganisationUserReducerAction.INIT:
      const { first_name, last_name, email, active } = action.value;
      const obj = {
        first_name,
        last_name,
        email,
        active,
      };
      return { ...(obj as OrganisationUser) };
    default:
      throw new Error();
  }
};
